const language = {
    'pt':
    {
        add_new_software: 'Adicionar Novo Software',
        add_new: 'Adicionar Novo Departamento',
        cancel: 'Cancelar',
        back: 'Voltar',
        category: 'Departamento',
        category_new: 'Novo Departamento',
        category_edit: 'Editar Departamento',
        category_list: 'Lista de Departamentos',
        category_view: 'Ver Departamento',
        close: 'Fechar',
        color: 'Cor',
        color_primary: 'Cor Primária',
        color_secondary: 'Cor Secundária',
        color_placeholder: 'Introduza a cor',
        contact: 'Contacto',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registo',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_confirm: 'Sim',
        delete_cancel: 'Não',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        edit: 'Editar',
        edit_title: 'Editar Registo',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_confirm: 'Sim',
        edit_cancel: 'Não',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        email: 'Email',
        entidade: 'Entidades',
        entidade_p: 'Entidades Patronais',
        filter_placeholder: 'Procurar',
        id: 'ID',
        name: 'Nome',
        name_placeholder: 'Introduza o nome',
        depart_name: 'Nome do departamento',
        insert_title: 'Novo Registo',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_confirm: 'Sim',
        insert_cancel: 'Não',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        of: 'de',
        principal: 'Principal',
        remove: 'Remover',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_title: 'Título',
        table_parent: 'Parent',
        table_date: 'Data',
        table_state: 'Estado',
        table_actions: 'Acções',
        table_empty: 'Nada a Apresentar',
        save: 'Salvar',
        softwares: 'Softwares',
        software_placeholder: 'Adicionar um novo software',
        local: 'Localidade',
        sede: 'Sede do departamento',
    },

    'en': {
        add_new_software: 'Add New Software',
        add_new: 'Add New Department',
        cancel: 'Cancel',
        back: 'Back',
        category: 'Department',
        category_new: 'New Department',
        category_edit: 'Edit Department',
        category_list: 'Department List',
        category_view: 'View Department',
        close: 'Close',
        color: 'Color',
        color_primary: 'Primary Color',
        color_secondary: 'Secondary Color',
        color_placeholder: 'Enter color',
        contact: 'Contact',
        delete: 'Delete',
        delete_title: 'Delete Record',
        delete_text: 'Are you sure you want to continue?',
        delete_confirm: 'Yes',
        delete_cancel: 'No',
        delete_error: 'Error deleting record!',
        delete_success: 'Record deleted successfully!',
        edit: 'Edit',
        edit_title: 'Edit Record',
        edit_text: 'Are you sure you want to continue?',
        edit_confirm: 'Yes',
        edit_cancel: 'No',
        edit_error: 'Error updating record!',
        edit_success: 'Record updated successfully!',
        email: 'Email',
        entidade: 'Entities',
        entidade_p: 'Employer Entities',
        filter_placeholder: 'Search',
        id: 'ID',
        name: 'Name',
        name_placeholder: 'Enter name',
        depart_name: 'Department Name',
        insert_title: 'New Record',
        insert_text: 'Are you sure you want to continue?',
        insert_confirm: 'Yes',
        insert_cancel: 'No',
        insert_error: 'Error inserting record!',
        insert_success: 'Record inserted successfully!',
        of: 'of',
        principal: 'Main',
        remove: 'Remove',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_all: 'All',
        table_title: 'Title',
        table_parent: 'Parent',
        table_date: 'Date',
        table_state: 'Status',
        table_actions: 'Actions',
        table_empty: 'Nothing to display',
        save: 'Save',
        softwares: 'Softwares',
        software_placeholder: 'Add a new software',
        local: 'Location',
        sede: 'Department Headquarters',
    },

    'es': {
        add_new: 'Añadir Nuevo Departamento',
        calendar: 'Calendario',
        cancel: 'Cancelar', back: 'Voltar',
        category: 'Departamento',
        category_new: 'Nuevo Departamento',
        category_edit: 'Editar Departamento',
        category_list: 'Lista de Departamentos',
        close: 'Cerrar',
        color: 'Color',
        color_primary: 'Color Primario',
        color_secondary: 'Color Secundario',
        color_placeholder: 'Ingrese el color',
        depart_name: 'Nombre del departamento',
        delete: 'Eliminar',
        delete_title: 'Eliminar Registro',
        delete_text: '¿Está seguro de que desea continuar?',
        delete_confirm: 'Sí',
        delete_cancel: 'No',
        delete_error: '¡Error al eliminar el registro!',
        delete_success: '¡Registro eliminado con éxito!',
        edit: 'Editar',
        edit_title: 'Editar Registro',
        edit_text: '¿Está seguro de que desea continuar?',
        edit_confirm: 'Sí',
        edit_cancel: 'No',
        edit_error: '¡Error al actualizar el registro!',
        edit_success: '¡Registro actualizado con éxito!',
        id: 'ID',
        name: 'Nombre',
        name_placeholder: 'Ingrese el nombre',
        insert_title: 'Nuevo Registro',
        insert_text: '¿Está seguro de que desea continuar?',
        insert_confirm: 'Sí',
        insert_cancel: 'No',
        insert_error: '¡Error al insertar el registro!',
        insert_success: '¡Registro insertado con éxito!',
        principal: 'Principal',
        remove: 'Eliminar',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_all: 'Todos',
        table_title: 'Título',
        table_parent: 'Padre',
        table_date: 'Fecha',
        table_state: 'Estado',
        table_actions: 'Acciones',
        table_empty: 'Nada que mostrar',
        save: 'Guardar',
        softwares: 'Programas',
        software_placeholder: 'Añadir un nuevo programa',
        local: 'Localidad',
        sede: 'Sede del departamento',
    },
    'fr': {
        add_new: 'Ajouter un nouveau département',
        calendar: 'Calendrier',
        cancel: 'Annuler',
        category: 'Département',
        category_new: 'Nouveau Département',
        category_edit: 'Modifier le Département',
        category_list: 'Liste des Départements',
        close: 'Fermer',
        color: 'Couleur',
        color_primary: 'Couleur Principale',
        color_secondary: 'Couleur Secondaire',
        color_placeholder: 'Insérer la couleur',
        depart_name: 'Nom du département',
        delete: 'Supprimer',
        delete_title: 'Supprimer l’Enregistrement',
        delete_text: 'Êtes-vous sûr de vouloir continuer ?',
        delete_confirm: 'Oui',
        delete_cancel: 'Non',
        delete_error: 'Problème lors de la suppression de l’enregistrement !',
        delete_success: 'Enregistrement supprimé avec succès !',
        edit: 'Modifier',
        edit_title: 'Modifier l’Enregistrement',
        edit_text: 'Êtes-vous sûr de vouloir continuer ?',
        edit_confirm: 'Oui',
        edit_cancel: 'Non',
        edit_error: 'Problème lors de la mise à jour de l’enregistrement !',
        edit_success: 'Enregistrement mis à jour avec succès !',
        id: 'ID',
        name: 'Nom',
        name_placeholder: 'Insérer le nom',
        insert_title: 'Nouvel Enregistrement',
        insert_text: 'Êtes-vous sûr de vouloir continuer ?',
        insert_confirm: 'Oui',
        insert_cancel: 'Non',
        insert_error: 'Problème lors de l’insertion de l’enregistrement !',
        insert_success: 'Enregistrement inséré avec succès !',
        principal: 'Principal',
        remove: 'Supprimer',
        table_rows_per_page: 'Enregistrements par page :',
        table_separator: 'de',
        table_all: 'Tous',
        table_title: 'Titre',
        table_parent: 'Parent',
        table_date: 'Date',
        table_state: 'État',
        table_actions: 'Actions',
        table_empty: 'Rien à afficher',
        save: 'Enregistrer',
        softwares: 'Logiciels',
        software_placeholder: 'Ajouter un nouveau logiciel',
        local: 'Localité',
        sede: 'Siège du département',
    }
}

module.exports = {
    language
};